import React from 'react'
import { Card, Col, Row, Typography } from 'antd'
import IntlMessages from 'util/IntlMessages'

const { Paragraph } = Typography

const Winter = () => {
	return (
		<Row>
			<Col xl={24} lg={24} md={24} sm={24} xs={24}>
				<Row gutter={32} type='flex'>
					<Col xl={12} lg={12} md={24} sm={24} xs={24}>
						<Card style={{ width: '100%', height: '85%' }} className='gx-card'>
							<Typography>
								<Paragraph>
									<IntlMessages id='winter.left.paragraph.1' />
								</Paragraph>
								{/* <Paragraph>
									<IntlMessages id='winter.left.paragraph.2' />
								</Paragraph> */}
							</Typography>
						</Card>
					</Col>
					<Col xl={12} lg={12} md={24} sm={24} xs={24}>
						<Card style={{ width: '100%', height: '85%' }} className='gx-card'>
							<Typography>
								<Paragraph>
									<IntlMessages id='winter.right.paragraph.1' />
								</Paragraph>
							</Typography>
						</Card>
					</Col>
				</Row>
			</Col>
			{/* <Col xl={24} lg={24} md={24} sm={24} xs={24}>
				<Card
					style={{ width: '100%' }}
					cover={<img alt='SSLCommerz Advertise' src={require('assets/images/sslcommerz-ad.png')} />}
					className='gx-card'
				>
				</Card>
			</Col> */}
		</Row>
	)
}

export default Winter
